import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio169: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-16-9, landscape"><path d="M1.75 5.75H22.25V18.25H1.75V5.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAspectRatio169;
